import { combineReducers } from '@reduxjs/toolkit'

import { sessionSlice } from '@/entities/session'
import { usersSlice } from '@/entities/user/model/slice'
import workOrderSlice from '@/entities/work_order/model/slice'
import { baseApi } from '@/shared/api'
import deliveryNoteSlice from '@/entities/delivery_note/model/slice'
import returnNoteSlice from '@/entities/return_note/model/slice'

export const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [sessionSlice.name]: sessionSlice.reducer,
  [usersSlice.name]: usersSlice.reducer,
  [workOrderSlice.name]: workOrderSlice.reducer,
  [deliveryNoteSlice.name]: deliveryNoteSlice.reducer,
  [returnNoteSlice.name]: returnNoteSlice.reducer,
})
